import { render, staticRenderFns } from "./WorldCupRanking.vue?vue&type=template&id=4a22d494&scoped=true&"
import script from "./WorldCupRanking.vue?vue&type=script&lang=js&"
export * from "./WorldCupRanking.vue?vue&type=script&lang=js&"
import style0 from "./WorldCupRanking.vue?vue&type=style&index=0&id=4a22d494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22d494",
  null
  
)

export default component.exports